<template>
  <el-dialog
    title="Cập nhật trang cá nhân"
    :visible.sync="dialogVisible"
    width="800px"
    :before-close="closeDialog"
    :close-on-click-modal="false"
    top="10vh"
    custom-class="profile-dialog"
  >
    <el-form
      class="profile-form"
      label-width="150px"
      :model="userData"
      label-position="left"
      :rules="rules"
      ref="userData"
    >
      <div class="profile-content">
        <el-row :gutter="20" type="flex" style="align-items: stretch;">
          <el-col :span="7">
            <div class="avatar-panel h-100">
              <p class="section-title">Ảnh đại diện</p>
              <div class="avatar-card">
                <div class="avatar-frame">
                  <el-image
                    v-if="avatarPreview"
                    class="avatar-preview"
                    :src="avatarPreview"
                    fit="cover"
                  ></el-image>
                  <div v-else class="avatar-placeholder">
                    <i class="el-icon-user-solid"></i>
                  </div>
                </div>

                <div class="avatar-meta">
                  <p class="avatar-name">{{ userData.fullName || userData.username || "Người dùng" }}</p>
                  <p class="avatar-hint">Hỗ trợ PNG, JPG, GIF • Tối đa 5MB</p>
                </div>

                <div class="avatar-actions">
                  <el-upload
                    class="avatar-uploader"
                    :show-file-list="false"
                    :on-change="handleChangeUpload"
                    :on-remove="handleRemove"
                    :auto-upload="false"
                    accept="image/jpeg,image/png,image/gif"
                    limit="1"
                    ref="upload"
                  >
                    <el-button class="upload-trigger" type="primary" plain>
                      <i class="el-icon-plus"></i>
                      <span>{{ avatarPreview ? "Đổi ảnh đại diện" : "Thêm ảnh đại diện" }}</span>
                    </el-button>
                  </el-upload>

                  <el-button
                    v-if="previewImage !== ''"
                    class="remove-trigger"
                    @click="handleRemove"
                  >
                    <i class="el-icon-delete"></i>
                    <span>Hủy ảnh mới</span>
                  </el-button>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="17">
            <div class="form-panel h-100">
              <p class="section-title">Thông tin cá nhân</p>
              <el-form-item label="Tài khoản" prop="username">
                <el-input disabled v-model="userData.username"></el-input>
              </el-form-item>
              <el-form-item label="Nickname/Họ tên" prop="fullName">
                <el-input
                  v-model="userData.fullName"
                  placeholder="Nhập Nickname/Họ tên"
                ></el-input>
              </el-form-item>
              <el-form-item label="Số điện thoại" prop="phone">
                <el-tooltip effect="dark" content="Số điện thoại nhận SMS" placement="top">
                  <el-input
                    v-model="userData.phone"
                    type="number"
                    placeholder="Nhập số điện thoại"
                  ></el-input>
                </el-tooltip>
              </el-form-item>
              <el-form-item label="Giới tính" prop="gender">
                <el-radio-group v-model="userData.gender" class="gender-group">
                  <el-radio label="Nam">Nam</el-radio>
                  <el-radio label="Nữ">Nữ</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item v-if="userData.appType === 'parent'" label="Ngày sinh">
                <el-date-picker
                  v-model="userData.birthday"
                  format="dd-MM-yyyy"
                  type="date"
                  :picker-options="pickerOptions"
                  style="width: 100%"
                  value-format="yyyy-MM-dd"
                  placeholder="Chọn ngày sinh"
                ></el-date-picker>
              </el-form-item>
              <el-form-item v-else label="Ngày sinh" prop="birthday">
                <el-date-picker
                  v-model="userData.birthday"
                  format="dd-MM-yyyy"
                  type="date"
                  :picker-options="pickerOptions"
                  style="width: 100%"
                  value-format="yyyy-MM-dd"
                  placeholder="Chọn ngày sinh"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="Email" prop="email">
                <el-input v-model="userData.email" placeholder="Nhập email"></el-input>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-form>
    <span slot="footer" class="dialog-footer profile-footer">
      <el-button class="btn-cancel" type="danger" size="medium" @click="closeDialogByButton('userData')">
        <i class="el-icon-circle-close" />
        <span>Đóng</span>
      </el-button>
      <el-button
        class="btn-save"
        type="success"
        size="medium"
        :loading="loadingButton"
        mini
        @click="submitForm('userData')"
      >
        <i class="el-icon-circle-check" />
        <span>Lưu</span>
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import MaUserService from "@/services/MaUserService";
import CommonOnekidsService from "@/services/CommonService/CommonOnekidsService";
export default {
  props: {
    dialogVisible: null,
  },
  data() {
    return {
      passwordData: {
        oldPassword: "",
        password: "",
        confirmPassword: "",
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      userData: {},
      imageUrl: "",
      previewImage: "",
      newGradeCreated: null,
      loadingButton: false,
      rules: {
        fullName: [
          {
            required: true,
            message: "Họ tên không được để trống",
            trigger: "blur",
          },
        ],
        phone: [
          {
            required: true,
            message: "Số điện thoại không được để trống",
            trigger: "change",
          },
          {
            min: 10,
            max: 10,
            message: "Số điện thoại bao gồm 10 số",
            trigger: "change",
          },
        ],
        gender: [
          {
            required: true,
            message: "Giới tính không được để trống",
            trigger: "change",
          },
        ],
        birthday: [
          {
            required: true,
            message: "Ngày sinh không được để trống",
            trigger: "change",
          },
        ],
      },
    };
  },
  computed: {
    avatarPreview() {
      if (this.previewImage !== "") {
        return this.previewImage;
      }
      return this.userData && this.userData.avatar ? this.userData.avatar : "";
    },
  },
  methods: {
    //reset when click x
    closeDialog() {
      this.$emit("dialog-close");
      setTimeout(() => {
        this.handleRemove();
      }, 300);
    },
    //click when click button
    closeDialogByButton() {
      this.$emit("dialog-close");
      setTimeout(() => {
        this.handleRemove();
      }, 300);
    },
    /**
     * click change image
     */
    handleChangeUpload(file) {
      this.beforeAvatarUpload(file);
      if (this.previewImage !== "") {
        URL.revokeObjectURL(this.previewImage);
      }
      this.imageUrl = file.raw;
      this.previewImage = URL.createObjectURL(file.raw);
    },
    /**
     * remove image
     */
    handleRemove() {
      if (this.previewImage !== "") {
        URL.revokeObjectURL(this.previewImage);
      }
      this.previewImage = "";
      this.imageUrl = "";
      if (this.$refs.upload) {
        this.$refs.upload.clearFiles();
      }
    },
    /**
     * check image before upload
     */
    beforeAvatarUpload(file) {
      const isJPG = file.raw.type === "image/jpeg";
      const isPNG = file.raw.type === "image/png";
      const isGIF = file.raw.type === "image/gif";
      const isLt5M = file.raw.size / 1024 / 1024 <= 5;
      if (!isJPG && !isPNG && !isGIF) {
        this.$message.error("Bạn phải chọn dạng ảnh");
        this.$refs.upload.clearFiles();
        throw "file not valid";
      }
      if (!isLt5M) {
        this.$message.error("Ảnh không được quá 5MB!");
        this.$refs.upload.clearFiles();
        throw "over size";
      }
    },
    setDataAgain() {
      CommonOnekidsService.getAvatar()
        .then((resp) => {
          let user = JSON.parse(localStorage.getItem("user"));
          user.avatar = resp.data.data;
          localStorage.setItem("user", JSON.stringify(user));
          this.$store.dispatch("auth/setUserActions", user);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    submitForm(fromData) {
      this.$refs[fromData].validate((valid) => {
        if (valid) {
          this.loadingButton = true;
          let inputData = this.userData;
          let formDatas = new FormData();
          for (let key in inputData) {
            formDatas.append(key, inputData[key]);
          }
          if (this.imageUrl !== "") {
            formDatas.append("multipartFile", this.imageUrl);
          }
          MaUserService.updateProfile(formDatas)
            .then((resp) => {
              this.$message({
                message: resp.data.message,
                type: "success",
              });
              setTimeout(() => {
                this.closeDialogByButton(fromData);
              }, 500);
              this.setDataAgain();
            })
            .catch((err) => {
              this.$message({
                message: err.response.data.message,
                type: "error",
              });
            })
            .finally(() => {
              setTimeout(() => {
                this.loadingButton = false;
              }, 500);
            });
        } else {
          console.log("error validate data!");
          return false;
        }
      });
    },
    getInitialData() {
      MaUserService.findProfile()
        .then((resp) => {
          this.handleRemove();
          this.userData = resp.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  beforeDestroy() {
    if (this.previewImage !== "") {
      URL.revokeObjectURL(this.previewImage);
    }
  },
};
</script>
<style lang="scss" scoped>
.profile-content {
  padding: 4px 0 6px;
}

.section-title {
  margin: 0 0 14px;
  font-size: 14px;
  font-weight: 700;
  color: #334155;
}

.h-100 {
  height: 100%;
  box-sizing: border-box;
}

.avatar-panel,
.form-panel {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 16px;
}

.avatar-panel {
  text-align: center;
}

.avatar-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
}

.avatar-frame {
  width: 170px;
}

.avatar-preview,
.avatar-placeholder {
  width: 170px;
  height: 170px;
  margin: 0 auto;
  border-radius: 20px;
}

.avatar-preview {
  display: block;
  overflow: hidden;
  box-shadow: 0 10px 20px rgba(0, 34, 102, 0.12);
}

.avatar-placeholder {
  background: linear-gradient(135deg, #eff6ff, #dbeafe);
  border: 1px dashed #93c5fd;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #3b82f6;
  font-size: 42px;
}

.avatar-meta {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.avatar-name {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  color: #1e293b;
}

.avatar-hint {
  margin: 0;
  font-size: 12px;
  line-height: 1.5;
  color: #64748b;
}

.avatar-actions {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.profile-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

/deep/.profile-dialog {
  border-radius: 20px;
  overflow: hidden;
}

/deep/.profile-dialog .el-dialog__header {
  padding: 18px 22px;
  border-bottom: 1px solid #f1f5f9;
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
}

/deep/.profile-dialog .el-dialog__body {
  padding: 18px 22px 8px;
}

/deep/.profile-dialog .el-dialog__footer {
  padding: 10px 22px 20px;
}

/deep/.el-dialog__title {
  font-size: 22px;
  font-weight: 700;
  color: #1e293b;
}

/deep/.el-form-item {
  margin-bottom: 16px;
}

/deep/.el-form-item__label {
  font-family: Inter, Arial, Helvetica, sans-serif;
  color: #475569;
  font-weight: 600;
}

/deep/.el-input__inner,
/deep/.el-textarea__inner {
  border-radius: 10px;
}

/deep/.el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:after {
  content: "*";
  color: #f56c6c;
  margin-left: 3px;
}

/deep/.el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
  content: "";
  color: #f56c6c;
  margin-left: -4px;
}

/deep/input::-webkit-outer-spin-button,
/deep/input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/deep/.el-input.is-disabled .el-input__inner {
  color: #606266;
  background: #e7e9ec;
}

/deep/.gender-group .el-radio {
  margin-right: 18px;
}

/deep/.avatar-uploader .el-upload {
  width: 100%;
}

/deep/.upload-trigger,
/deep/.remove-trigger {
  width: 100%;
  border-radius: 12px;
}

/deep/.upload-trigger {
  border-color: #93c5fd;
  background: #eff6ff;
  color: #2563eb;
}

/deep/.remove-trigger {
  border-color: #fecaca;
  color: #dc2626;
  background: #fff5f5;
}

/deep/.btn-cancel,
/deep/.btn-save {
  min-width: 110px;
  border-radius: 10px;
}
</style>
